var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('T1HeadScripts',{attrs:{"rodzajstrony":"zestawienia"}}),_c('a-layout',{staticClass:"layout",attrs:{"id":"components-layout-demo-top"}},[_c('T1Header'),_c('T1SzukajContent'),_c('T1Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }